module.exports = __webpack_public_path__ + "img/faster_option.984b4a08.svg";